/* eslint-disable react/jsx-one-expression-per-line */
import React from 'react';
import { Alert } from 'reactstrap';
import SortIcons from './ProposalsSortIcons';
import EnterpriseGroup from './EnterpriseGroup';
import loadingSpinner from '../Res/logo-loading.gif';

const styles = { loadingSpinner: { height: '200px' } };

const EnterpriseAdminList = ({
  companies = [],
  onDelete,
  onEdit,
  onSetStatus,
  deleteMode,
  onRecover,
  onSort,
  sortValue,
  isLoading
}) => {
  if (isLoading) {
    return (
      <img src={loadingSpinner} alt="loading" className='pb-4' style={styles.loadingSpinner} />
    );
  }

  return (
    <div className="table-header-fixed">
      <table>
        <thead>
          <tr>
            <th className="cursor-pointer" onClick={() => onSort('name')}>
              Enterprise Group Name <SortIcons sortObj={sortValue} sortName="name" />
            </th>
            <th className="cursor-pointer" onClick={() => onSort('managementCompany.name')}>
              Management Company <SortIcons sortObj={sortValue} sortName="managementCompany.name" />
            </th>
            <th>Customer ID</th>
            <th>Member Users</th>
            <th>Managed Companies</th>
            <th>Managed Devices</th>
            <th>Monitored Devices</th>
            <th colSpan="1">Actions</th>
          </tr>
        </thead>
        <tbody>
          {companies && companies.length ? (
            companies.map(company => (
              <EnterpriseGroup
                onRecover={onRecover}
                deleteMode={deleteMode}
                key={company._id}
                company={company}
                onDelete={onDelete}
                onSetStatus={onSetStatus}
                onEdit={onEdit}
                // disabled={company._id === disabledCompany}
              />
            ))
          ) : (
            <tr>
              <td colSpan={5}>
                <Alert rowSpan={5} color="info">
                  No Enterprise Admins Found
                </Alert>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default EnterpriseAdminList;